<a href="{{ url }}" [ngClass]="btnClass" download="{{ filename }}">
	<ng-content></ng-content>
</a>
